{
  "invite": "Пригласить",
  "emptyTitle": "В организации только вы",
  "emptyHint": "Пригласите инженеров и наблюдателей. Пароль сгенерирует система — он показывается один раз и подлежит смене при первом входе.",
  "loadFailed": "Не удалось загрузить пользователей",
  "loadFailedHint": "{{reason}} Возможно, у вас нет права org:admin.",
  "passwordNotChanged": "пароль не сменён",
  "neverLoggedIn": "ни разу",
  "itIsYou": "это вы",
  "editAria": "Изменить {{name}}",
  "editTitle": "Изменить имя и роли",
  "resetAria": "Сбросить пароль {{name}}",
  "resetTitle": "Сбросить пароль: прежний перестанет работать, открытые сессии закроются",
  "resetConfirm": "Сбросить пароль «{{name}}»? Прежний перестанет работать, а открытые сессии закроются.",
  "resetFailed": "Сбросить пароль не удалось",
  "disableAria": "Отключить {{name}}",
  "enableAria": "Включить {{name}}",
  "disableTitle": "Отключить учётную запись",
  "enableTitle": "Включить учётную запись",
  "passwordReset": "Пароль {{name}} сброшен",
  "userCreated": "Пользователь {{name}} создан",
  "temporaryPasswordNote": "Передайте временный пароль лично. Он показывается один раз и на сервере в открытом виде не хранится.",
  "oldPasswordDead": "Прежний пароль больше не работает, открытые сессии закрыты.",
  "written": "Я записал",
  "status": {
    "active": "Активен",
    "disabled": "Отключён"
  },
  "column": {
    "name": "Пользователь",
    "email": "Адрес",
    "roles": "Роли",
    "lastLogin": "Последний вход"
  },
  "form": {
    "name": "Имя",
    "namePlaceholder": "Иван Петров",
    "emailHint": "только латиница в имени ящика",
    "role": "Роль",
    "roleRequired": "Нужна хотя бы одна роль: без прав учётная запись выглядит рабочей, но ничего не может."
  }
}
